import { CheckCircleOutlineOutlined } from "@mui/icons-material";
import { Alert, Card, CardContent, Typography } from "@mui/material";
import { CreditCard } from "@phosphor-icons/react";

type Props = {
    lead: any
}
const BillingStatus = ({lead}:Props) => {
    return (
        <Card sx={{borderRadius: 1}}>
            <CardContent sx={{p:0, '&:last-child':{paddingBottom: 0}}}>
                <Typography variant="subtitle1" sx={{m:2, mb:3}}><CreditCard className="me-2"/>{'Billing Status'}</Typography>
                <Alert icon={<CheckCircleOutlineOutlined fontSize="inherit" />} severity={(lead && lead.LeadStatus === 'Inactive')?'error':'success'} sx={{m:2, mb:3}}>
                    {(lead && lead.LeadStatus === 'Inactive')?'Inactive':'Active'}
                </Alert>
            </CardContent>
        </Card>
    );
}

export default BillingStatus;